<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined
          v-model="formattedDate"
          :label="label"
          readonly
          v-bind="attrs"
          v-on="on"
          :class="className"
        ></v-text-field>
      </template>
      <v-date-picker
        no-title
        v-model="date"
        :active-picker.sync="activePicker"
        :max="max"
        :min="min"
        @change="save"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    value: String,
    label: String,
    max: String,
    min: String,
    className: String
  },
  emits: ['update:date'],
  data: function () {
    return {
      activePicker: null,
      formattedDate: '',
      date: '',
      menu: false
    };
  },
  watch: {
    '$props.value': function (value, prevValue) {
      if (prevValue && prevValue !== value) {
        const date = moment(value, 'MM/DD/YYYY');
        this.$data.date = date.format('YYYY-MM-DD');
        this.$data.formattedDate = date.format('MM/DD/YYYY');
      }
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    }
  },
  methods: {
    save(value) {
      if (value) {
        const formattedDate = moment(value).format('MM/DD/YYYY');
        this.$data.formattedDate = formattedDate;
        this.$emit('input', formattedDate);
        this.$refs.menu.save(formattedDate);
      }
    }
  }
};
</script>
